// extracted by mini-css-extract-plugin
export var actions = "_4u-0";
export var actionsContainer = "_4u-7";
export var border = "_4u-1";
export var childFullHeight = "_4u-f";
export var collapse = "_4u-2";
export var content = "_4u-a";
export var contentChild = "_4u-e";
export var fullscreen = "_4u-c";
export var hasLeftRadius = "_4u-k";
export var headerContainer = "_4u-3";
export var headerRow = "_4u-5";
export var hidePadding = "_4u-b";
export var navCollapsedGap = "_4u-l";
export var noScrollX = "_4u-m";
export var noScrollY = "_4u-n";
export var noTopPadding = "_4u-i";
export var optOutTopPadding = "_4u-d";
export var pageMain = "_4u-j";
export var pageOuter = "_4u-g";
export var pagePadding = "_4u-8";
export var pageScroll = "_4u-9";
export var profile = "_4u-o";
export var profileContainer = "_4u-p";
export var profileImage = "_4u-q";
export var profileMain = "_4u-r";
export var profileSubtitle = "_4u-t";
export var profileTitle = "_4u-s";
export var showLeftPadding = "_4u-h";
export var tabsPortalSlot = "_4u-6";
export var tabsWrapper = "_4u-4";
export var title = "_4u-u";